import React, { Component, useCallback } from 'react';
import {FormControl} from 'react-bootstrap';
import moment from 'moment';

import TimePicker from 'react-bootstrap-time-picker';

class TimePickerComponent extends Component{
  constructor(props){
    super(props);

    this.state = {
      value:props.value || '',
      view:'input'
    };
  }

  onDoubleClick = () =>{
    const dbclick = this.props.dbclick === null || this.props.dbclick === undefined ? true : this.props.dbclick;

    if(dbclick) this.setState({ view:'select' });
  }

  onClick = () =>{
    const value = moment().format('hh:mm A');

    this.setState({
      value,
      view:'input'
    },() => this.onValueChange());
  }

  onChange = (time) =>{
    const value = moment().startOf('day').add(time * 1000).format('hh:mm A');

    this.setState({
      value,
      view:'input'
    },() => this.onValueChange());
  }

  onChangeText = (value) =>{
    this.setState({
      value
    },() => this.onValueChange());
  }

  onValueChange = () =>{
    const {value} = this.state;

    if(this.props.onChange){
      this.props.onChange(value);
    }
  }

  render(){
    const {view,value} = this.state;

    if(view === 'select'){
      return <TimePicker disabled={this.props.disabled} value={value} onChange={this.onChange} autoFocus={true}/>
    }

    return (
      <FormControl 
        disabled={this.props.disabled} 
        type={'input'} 
        placeholder={'Click to set'} 
        onDoubleClick={this.onDoubleClick} 
        defaultValue={value} 
        onClick={this.onClick}
        onChange={(e) => this.onChangeText(e.target.value)}
      />
    )
  }
}

export default TimePickerComponent;
